import { render, staticRenderFns } from "./AccountMinus.vue?vue&type=template&id=41f3e753"
import script from "./AccountMinus.vue?vue&type=script&lang=js"
export * from "./AccountMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports